import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';
import {validatable} from 'components/utils';

class DropDownChonLinhVucDonThuChiTiet extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      linhVucDonThuID: null,
      loaiDonThuID: null,
      data: [],
      allData: []
    }
  }
  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {
  }

  loadData(linhVucDonThuID, loaiDonThuID) {
    let params = {
      cha: linhVucDonThuID,
      loaiDon: loaiDonThuID
    }
    DuLieuHeThong.actions.getLinhVucDonThu.request(params).then(res => {
      if (typeof res.data._embedded != "undefined") {
        // TODO: Use Redux

        this.setState({
          data: res.data._embedded.linhVucDonThus
        })
      } else {
        this.setState({
          data: []
        });
      }
    }).catch(err => {})
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.linhVucDonThuID && this.props.linhVucDonThuID != nextProps.linhVucDonThuID) {
      if (typeof this.state.allData[nextProps.linhVucDonThuID] != "undefined") {
        this.setState({
          data: this.props.data[nextProps.linhVucDonThuID]
        });
      } else {
        this.loadData(nextProps.linhVucDonThuID, nextProps.loaiDonThuID);
      }
    } else if (nextProps.linhVucDonThuID == '' || nextProps.loaiDonThuID == '') {
      this.setState({
        data: []
      });
    }
  }

  render() {
    return (
      <div>
      {
        this.state.data.length > 0 || !this.props.allowHidden ?
          <DropDown
            className={this.props.className}
            selectedValue={this.props.selectedValue}
            label={this.props.label}
            bindValidator={this}
            channel="formTaoDon"
            require={this.props.require}
            options={ this.state.data }
            keyName='linhVucDonThuId'
            valueName='ten'
            onChange={ this.onChange.bind(this) }
            placeholder={ this.props.placeholder }
            name={this.props.name}
          />
        : ''
      }
      </div>
    )
  }
}

DropDownChonLinhVucDonThuChiTiet.defaultProps = {
  allowHidden: true,
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  label: 'Lĩnh vực chi tiết',
  className: "col-input",
  name: ''
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.capQuanHuyen
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonLinhVucDonThuChiTiet));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonlinhvucdonthuchitiet.jsx